import { render, staticRenderFns } from "./dust-area-equipments-count-chart.component.vue?vue&type=template&id=4f038f54&scoped=true"
import script from "./dust-area-equipments-count-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./dust-area-equipments-count-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./dust-area-equipments-count-chart.component.vue?vue&type=style&index=0&id=4f038f54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f038f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f038f54')) {
      api.createRecord('4f038f54', component.options)
    } else {
      api.reload('4f038f54', component.options)
    }
    module.hot.accept("./dust-area-equipments-count-chart.component.vue?vue&type=template&id=4f038f54&scoped=true", function () {
      api.rerender('4f038f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/charts/dust-area-equipments-count-chart.component.vue"
export default component.exports